import { cacheAdapterEnhancer } from 'axios-extensions';
import config from "../const/config";
import { getWorkingCompanyHeaders } from "./workingCompany";
const axios = require('axios');

const axiosOptions = {
    baseURL: config.url + '/api/v1',
    timeout: 6 * 1000 * 10 * 10 * 2, // 20분
    headers: {
        'x-token': sessionStorage.getItem(config.keyToken), 'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0'
    },
    adapter: cacheAdapterEnhancer(axios.defaults.adapter, { enabledByDefault: false }),
}

const instance = axios.create(axiosOptions);

/**
 * 매 요청:
 * - x-token 최신화
 * - 특사 + manage_company_idx → x-company-idx (asset 단일 경로용)
 * - /admin 요청에는 회사 헤더를 붙이지 않음
 */
function applyAuthAndCompanyHeaders(reqConfig) {
    const headers = reqConfig.headers || {};
    const token = sessionStorage.getItem(config.keyToken);
    if (token) {
        headers['x-token'] = token;
        headers['X-token'] = token;
    }
    const urlHint = String(reqConfig.url || '');
    const isAdmin = urlHint.includes('/admin/') || urlHint.startsWith('admin/');
    if (!isAdmin) {
        const companyHeaders = getWorkingCompanyHeaders();
        Object.keys(companyHeaders).forEach((key) => {
            headers[key] = companyHeaders[key];
        });
    }
    reqConfig.headers = headers;
    return reqConfig;
}

instance.interceptors.request.use((reqConfig) =>
    applyAuthAndCompanyHeaders(reqConfig)
);

//* No interceptors is attached to this instance historically; keep same company/token behavior
export const AXIOS = axios.create(axiosOptions);
AXIOS.interceptors.request.use((reqConfig) =>
    applyAuthAndCompanyHeaders(reqConfig)
);

export default instance;
